import { styles } from '../../vehicle-card.styles';
import { myAdsTestId } from '../../../../utils';
import type { TCardInfoConfig } from '../../vehicle-card.types';

const CardInfo = ({ adId, title, version, yearDisplay }: TCardInfoConfig) => {
	return (
		<div className={styles.infoStack} data-testid={myAdsTestId.cardInfo(adId)}>
			<h3 className={styles.title}>{title}</h3>
			<p className={styles.version}>{version}</p>
			<p className={styles.yearKm}>{yearDisplay}</p>
		</div>
	);
};

CardInfo.displayName = 'CardInfo';

export { CardInfo };
